import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueSession from 'vue-session'
// import VueQRCodeComponent from 'vue-qr-generator'

Vue.use(VueSession)
Vue.config.productionTip = false
Vue.prototype.axios= axios

new Vue({
  router,
  store,
  axios,
  vuetify,
  render: h => h(App)
}).$mount('#app')
